export default "__VITE_ASSET__fd092961__$_?react__"